import { UseCase } from '@/core/base/use-case';
import { Observable } from 'rxjs';
import { CountDestinationsResponse } from '../models/count-destinations.model';
import { CountDestinationsRepository } from '../repositories/count-destinations.repository';

export class GetCountDestinationsUseCase
    implements UseCase<never, CountDestinationsResponse>
{
    constructor(private readonly repository: CountDestinationsRepository) {}

    execute(): Observable<CountDestinationsResponse> {
        return this.repository.getCountDestinations();
    }
}
